import * as React from 'react';
import styled from 'styled-components';
import {HyperLink} from '../../HyperLink';

import {BREAKPOINTS, COLORS} from '../../styles';
import {ComponentTextStyle, ComponentXSStyling} from '../../styles/typography';

const FooterLinkSection = styled.section`
  min-height: 64px;
  color: white;
  display: flex;
  flex-direction: column;

  ${BREAKPOINTS.MEDIUM} {
    flex-direction: row;
  }
`;

const FooterLinks = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0 auto;

  ${BREAKPOINTS.MEDIUM} {
    flex-direction: row;
    margin: auto auto auto 0;
  }

  a {
    ${ComponentXSStyling(ComponentTextStyle.Bold, null)}
    &:not(:first-child) {
      margin: 16px 0 0 0;
      ${BREAKPOINTS.MEDIUM} {
        margin: 0 0 0 16px;
      }
    }
  }
`;

const Copyright = styled.div`
  ${ComponentXSStyling(ComponentTextStyle.Regular, COLORS.white)}
  margin: 16px auto 0 auto;

  ${BREAKPOINTS.MEDIUM} {
    margin: auto 0 auto auto;
  }
`;

interface Link {
  label: string;
  to: string;
  target?: string;
}

interface FooterLinkProps {
  bottomLinks?: Link[];
  copyrightText?: string;
}

const FooterBottomLinks = ({ bottomLinks, copyrightText }: FooterLinkProps) => {
  return (
    <FooterLinkSection>
      <FooterLinks>
        {bottomLinks?.map((bl, i) => (
          <HyperLink id={`FooterLink_${Math.floor(Math.random() * 999999999999)}`}
                     key={i}
                     href={bl.to} variant="inverted">
            {bl.label}
          </HyperLink>
        ))}
      </FooterLinks>
      <Copyright>{copyrightText}</Copyright>
    </FooterLinkSection>
  );
};

export default FooterBottomLinks;
